"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles = (theme) => {
    const budgetContainer = {
        cursor: 'pointer',
        padding: 20,
        textAlign: 'left',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: 'auto',
    };
    const budgetTitle = Object.assign(Object.assign({}, theme.typography.body2), { fontSize: '15px', fontWeight: 400, paddingTop: 4, paddingBottom: 4, marginBottom: 0, justifyContent: 'center' });
    const categoryGroup = {
        color: 'black',
        cursor: 'pointer',
        marginBottom: 0,
        '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.035)',
        },
    };
    return ({
        root: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
        },
        budgetContainer,
        budgetContainerSparse: Object.assign(Object.assign({}, budgetContainer), { justifyContent: 'space-evenly' }),
        select: {
            color: 'black',
            fontSize: 13,
            marginBottom: 0,
        },
        subtitles: {
            fontWeight: 500,
        },
        annotations: {
            color: '#333',
            fontSize: 13,
        },
        budgetTitle,
        budgetTitleDense: Object.assign(Object.assign({}, budgetTitle), { marginBottom: 0 }),
        annotationsWrap: {
            display: 'flex',
            justifyContent: 'space-between',
        },
        categoryGroup,
        categoryGroupDense: Object.assign(Object.assign({}, categoryGroup), { marginBottom: 10 }),
        moreButton: {
            textAlign: 'right',
            color: theme.palette.linkColor,
            textDecoration: 'none',
            position: 'relative',
            top: -5,
        },
    });
};
exports.default = styles;
